// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__s3uSW"};